module.exports = __webpack_public_path__ + "static/shoe-yellow-2-685e6ae1804594aa6438f6131097c69f.jpg";